{
	"accounts": "Акаунти",
	"invitations": "Покани",
	"subscribeToFeedback": "Абонирайте се за програмата за обратна връзка",
	"notificationSettings": {
		"title": "Настройки за имейл известия",
		"invoicingInformation": "Информация за фактуриране",
		"declarationProcessingStatus": "Статус на обработка на декларация",
		"enabled": "Вкл.",
		"disabled": "Изкл.",
		"toast": {
			"success": "Предпочитанието за известия е актуализирано",
			"error": "Неуспешно актуализиране на предпочитанието за известия"
		}
	},
	"about": {
		"title": "Относно",
		"termsAndConditions": "Общи условия",
		"privacyPolicy": "Политика за поверителност",
		"imprint": "Импресум",
		"openSourceAttribution": "Признания за отворен код"
	},
	"language": {
		"title": "Език",
		"footer": "Промените на езика ще се приложат към всички приложения на Heidelberg Materials"
	},
	"impressum": "Импресум",
	"copyright": "© 2024 Heidelberg Materials. Всички права запазени.",
	"login": "Вход",
	"logout": "Изход"
}
